import { api } from '../intreceptor/apiInterceptor';

interface BlitzSchedule {
  isScheduled: boolean;
  weekdays: string[];
  startTime: string;
  endTime: string;
  startDate: string;
  endDate: string;
}

interface BlitzStatus {
  status: string;
}

interface BlitzResponse {
  message: string;
}

export const blitzService = {
  async scheduleBlitzMode(scheduleData: BlitzSchedule): Promise<any> {
    try {
      return await api.fetch('/blitz-mode/schedule', {
        method: 'POST',
        body: JSON.stringify(scheduleData),
        requiresAuth: true
      });
    } catch (error) {
      console.error('Error scheduling blitz mode:', error);
      throw error;
    }
  },

  async getBlitzStatus(): Promise<BlitzStatus> {
    try {
      return await api.fetch('/blitz-mode/status', {
        method: 'GET',
        requiresAuth: true
      });
    } catch (error) {
      console.error('Error getting blitz mode status:', error);
      throw error;
    }
  },

  async activateBlitzMode(): Promise<BlitzResponse> {
    try {
      return await api.fetch('/blitz-mode/activate', {
        method: 'POST',
        requiresAuth: true
      });
    } catch (error) {
      console.error('Error activating blitz mode:', error);
      throw error;
    }
  },

  async deactivateBlitzMode(): Promise<BlitzResponse> {
    try {
      return await api.fetch('/blitz-mode/deactivate', {
        method: 'POST',
        requiresAuth: true
      });
    } catch (error) {
      console.error('Error deactivating blitz mode:', error);
      throw error;
    }
  },

  async cancelSchedule(): Promise<BlitzResponse> {
    try {
      return await api.fetch('/blitz-mode/cancel-schedule', {
        method: 'POST',
        requiresAuth: true
      });
    } catch (error) {
      console.error('Error canceling blitz mode schedule:', error);
      throw error;
    }
  }
};

